<template>
    <div class="menu_couriers__switch">
        <div class="menu_couriers__switch_container">
            <burger_menu
                v-if="isMobileScreen"
                :key="'burger_menu'"
            />
            <div class="menu_couriers__switch_buttons">
                <button @click.prevent="clickButtonActive" class="menu_couriers__switch_buttons_button_active"
                        :class="classButtonActive">
                    <div class="menu_couriers__switch_buttons_button_active_text">
                        {{ __t('O.ACTIVE') }}
                    </div>
                </button>
                <button @click.prevent="clickButtonCompleted" class="menu_couriers__switch_buttons_button_completed"
                        :class="classButtonCompleted">
                    <div class="menu_couriers__switch_buttons_button_completed_text">
                        {{ __t('O.COMPLETED') }}
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import burger_menu from "../../heading/BurgerMenu.vue";
import {screenSize} from "../../../mixins/screenSize";

export default {
    name: "switch_panel_couriers",
    props: {},
    emits: ['click_switch_button'],
    components: {burger_menu},
    mixins: [screenSize],
    data() {
        return {
            isActiveCourierButton: true,
        }
    },
    methods: {
        clickButtonActive() {
            this.isActiveCourierButton = true;
            this.$emit('click_switch_button', true);
        },
        clickButtonCompleted() {
            this.isActiveCourierButton = false;
            this.$emit('click_switch_button', false);
        }
    },
    computed: {
        classButtonActive() {
            if (this.isActiveCourierButton) {
                return {'active': true};
            }
            return {'active': false};
        },
        classButtonCompleted() {
            if (this.isActiveCourierButton) {
                return {'active': false};
            }
            return {'active': true};
        }
    },
}
</script>
